<template>
  <div>
    <sj-button style="margin:10px" @click="click1">download</sj-button>
  </div>
</template>

<script>
export default {
  methods: {
    click1() {
      this.$SjDownload({
        download: "test.xlsx",
        href:
          "http://ruiyuan.shangjian.tech:8889/data_storage/env_storage/research_report/contacts/20191017225114_cdee8fc03ad24a82a293a6294e1e46b4.xlsx"
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
